import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Modal, styled, Typography } from '@mui/material';

export const LabelStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'useOtp',
})(({ theme, useOtp }) => ({
  color: theme.palette.colors.onPrimaryBackground,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textDecoration: 'underline',
  cursor: 'pointer',
  marginBottom: useOtp ? '24px' : '34px',

  '&[aria-disabled="true"]': {
    color: theme.palette.colors.off,
  },

  [theme.breakpoints.up('lg')]: {
    marginBottom: 0,
  },
}));

export const ModalStyled = styled(Modal)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.colors.lockedBackground,
  },
}));

export const PasswordRecover = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.colors.primaryBackground,
  p: 4,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 400,
  padding: 50,
  flexWrap: 'wrap',
  flexDirection: 'column',

  '& .exit': {
    position: 'absolute',
  },
  '& button': {
    margin: '0 auto',
  },
  '& .bem-vindo': {
    color: theme.palette.colors.onPrimaryBackground,
    marginBottom: '25px',
  },
  '& .submitBtnContainer': {
    marginTop: '20px',
  },

  [theme.breakpoints.down('lg')]: {
    width: 400,
  },
  [theme.breakpoints.down('md')]: {
    width: 360,
  },
}));

export const CloseIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  alignSelf: 'end',
  cursor: 'pointer',
  position: 'relative',
  top: '16px',
  right: '16px',
  color: theme.palette.colors.onPrimaryBackground,
}));

export const InputsContainerStyled = styled(Box)(() => ({
  width: '247px',
}));

export const SubmitButtonContainerStyled = styled(Box)(({ theme }) => ({
  width: '247px',
  marginTop: theme.spacing(6),
}));
